import { useEffect, useState } from 'react';
import { Icon } from '../../../lib/icon/Icon';
import { cn } from '../../../lib/utils';

interface LoadingOverlayProps {
  /** Always-mount; toggle visibility. Prevents translate-reconciliation crash. WWP-423. */
  open: boolean;
  label: string;
  labelHidden?: boolean;
  delay?: number;
  className?: string;
}

function LoadingOverlay({ open, label, labelHidden = false, delay = 300, className }: LoadingOverlayProps) {
  const [delayElapsed, setDelayElapsed] = useState(delay === 0);

  useEffect(() => {
    if (!open) {
      setDelayElapsed(delay === 0);
      return;
    }
    if (delay === 0) {
      setDelayElapsed(true);
      return;
    }
    const timer = setTimeout(() => setDelayElapsed(true), delay);
    return () => clearTimeout(timer);
  }, [open, delay]);

  const visible = open && delayElapsed;

  return (
    <div
      role="status"
      aria-live="polite"
      hidden={!visible}
      className={cn('fixed inset-0 z-50 flex items-center justify-center bg-black/80', className)}
    >
      {visible ? (
        <div className="flex flex-col items-center justify-center gap-2">
          <Icon name="loader" size="2xl" className="animate-spin text-white" />
          <span className={labelHidden ? 'sr-only' : 'text-sm text-white/80'}>{label}</span>
        </div>
      ) : null}
    </div>
  );
}

export type { LoadingOverlayProps };
export { LoadingOverlay };
